import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/inventory-vendors/profile/loading';

export const Route = createFileRoute('/_private/settings/inventory-vendors/$id')({
  pendingComponent: Loading,
});
